import React from 'react';
import PropTypes from 'prop-types';
import Window from './Window';
import AddressToolbar from './AddressToolbar';

const Browser = ({
    children,
    title,
    address,
    history
}) => {
    const toolbar = <AddressToolbar address={address} history={history} />;
    return (
        <Window title={title} toolbar={toolbar}>
            {children}
        </Window>
    );
};

Browser.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    address: PropTypes.string,
    history: PropTypes.arrayOf(PropTypes.string)
};

export default Browser;



// WEBPACK FOOTER //
// ./src/components/Browser/index.jsx